import React from "react";
import PropTypes from "prop-types";

export default function FormError({ message, className = "" }) {
  if (!message) return null;
  return (
    <small className={`text-danger mt-1 d-block ${className}`}>{message}</small>
  );
}

FormError.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string
};
